import { RunFacetField } from '@/types/schema';

/**
 * Filters facets based on search query with special handling for feedback category
 * to include parent feedback_key items when their values match the search.
 */
export function filterFacets(
  facets: RunFacetField[],
  searchQuery: string,
  categoryName: string
): RunFacetField[] {
  const trimmedSearchQuery = searchQuery.trim();
  // For feedback category, first collect all feedback keys that have matching values
  const matchedFeedbackKeys = new Set<string>();
  if (categoryName === 'feedback') {
    facets.forEach((facet) => {
      if (
        (facet.key === 'feedback_value' ||
          facet.key === 'feedback_key_score') &&
        facet.value.toLowerCase().includes(trimmedSearchQuery.toLowerCase())
      ) {
        const feedbackKey = facet.value.split(' == ')[0];
        matchedFeedbackKeys.add(feedbackKey);
      }
    });
  }

  // Filter the original facets array with combined logic
  const filteredFacets = facets.filter((facet) => {
    const searchText = facet.value.toLowerCase();
    const matchesSearch = searchText.includes(trimmedSearchQuery.toLowerCase());

    // For feedback category, also include feedback_key items whose values match
    if (categoryName === 'feedback' && facet.key === 'feedback_key') {
      return matchesSearch || matchedFeedbackKeys.has(facet.value);
    }

    return matchesSearch;
  });
  filteredFacets.sort((a, b) => {
    if (a.key.endsWith('_score') && b.key.endsWith('_score')) {
      const [aKey, aValue] = a.value.split(' == ');
      const [bKey, bValue] = b.value.split(' == ');
      // only order by value if the key is the same
      if (aKey === bKey) {
        return parseFloat(aValue) - parseFloat(bValue);
      }
    }
    return 0;
  });

  return filteredFacets;
}

export function categoryKey(facet: RunFacetField) {
  let key = facet.key;
  if (key.startsWith('feedback_') && key !== 'feedback_source') {
    key = 'feedback';
  }
  if (key.startsWith('metadata_')) key = 'metadata';
  if (key.startsWith('input_')) key = 'input';
  if (key.startsWith('output_')) key = 'output';
  if (key.startsWith('name')) key = 'run_name';
  return key;
}
